import React from "react";
import "./Skills.scss";
import {aboutSection, skillsSection} from "../../portfolio";
import {Fade} from "react-reveal";

const designMetrics = [
  {label: "Design", value: 85},
  {label: "Branding", value: 95},
  {label: "Ecommerce", value: 80}
];

const developerMetrics = [
  {label: "Python", value: 90},
  {label: "JavaScript", value: 85},
  {label: "React", value: 80},
  {label: "HTML5", value: 75},
  {label: "CSS3", value: 75},
  {label: "Node.js", value: 71},
  {label: "PostgreSQL", value: 78}
];

const languageMetrics = [
  {label: "English", value: 85},
  {label: "Ndebele", value: 95},
  {label: "Shona", value: 90}
];

function DonutSkill({label, value}) {
  return (
    <div className="skill-donut-card">
      <div
        className="skill-donut"
        style={{"--skill-value": `${value * 3.6}deg`}}
      >
        <span>{value}%</span>
      </div>
      <p>{label}</p>
    </div>
  );
}

function SkillBars() {
  return (
    <div className="skill-bars">
      {developerMetrics.map(skill => (
        <div className="skill-bar-row" key={skill.label}>
          <div className="skill-bar-label">
            <span>{skill.label}</span>
            <strong>{skill.value}%</strong>
          </div>
          <div className="skill-bar-track">
            <span style={{width: `${skill.value}%`}} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Skills() {
  if (!skillsSection.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="24px">
      <section className="skills-showcase" id="skills">
        <div className="skill-hero">
          <div
            className="skill-hero-photo"
            style={{backgroundImage: `url(${aboutSection.image})`}}
            aria-label={aboutSection.imageAlt}
            role="img"
          />

          <div className="skill-hero-panel">
            <span className="skill-hero-small-mark" aria-hidden="true" />
            <span className="skill-hero-word" aria-hidden="true">
              Power
            </span>
            <div className="skill-hero-copy">
              <h2>
                My own <span>developer's</span> and
                <br />
                design skills
              </h2>
            </div>
          </div>
        </div>

        <div className="skill-attainments">
          <span className="skill-slashes" aria-hidden="true">
            {"//"}
          </span>
          <span className="skill-bg-word" aria-hidden="true">
            Attainments
          </span>

          <div className="skill-row skill-design-row">
            <div className="skill-section-title">
              <span aria-hidden="true" />
              <h3>Design Skills</h3>
            </div>
            <div className="skill-donut-grid">
              {designMetrics.map(skill => (
                <DonutSkill key={skill.label} {...skill} />
              ))}
            </div>
          </div>

          <div className="skill-row skill-developer-row">
            <div className="skill-section-title">
              <span aria-hidden="true" />
              <h3>Developer Skills</h3>
            </div>
            <SkillBars />
          </div>

          <div className="skill-row skill-language-row">
            <div className="skill-section-title">
              <span aria-hidden="true" />
              <h3>Language Skills</h3>
              <p>Communication is key!</p>
            </div>
            <div className="skill-donut-grid">
              {languageMetrics.map(skill => (
                <DonutSkill key={skill.label} {...skill} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fade>
  );
}
